// extracted by mini-css-extract-plugin
module.exports = {"qbsWrapper":"styles-module__qbsWrapper___Sf4if","qbsHeader":"styles-module__qbsHeader___3Gxoa","qbsBody":"styles-module__qbsBody___3D6CH"};